import axios from "axios";
import { createContext } from "react";

const SeatApplicationManagerContext = createContext();

export const SeatApplicationManagerContextProvider = ({ children }) => {

  const getInstalledApplications = () => {
    return axios.get("/api/seat/applications/installed");
  };
  const getInstalledAccountApplications = () => {
    return axios.get("/api/seat/account-applications/installed");
  }

  return (
    <SeatApplicationManagerContext.Provider
      value={{
        getInstalledApplications,
        getInstalledAccountApplications
      }}
    >
      {children}
    </SeatApplicationManagerContext.Provider>
  );
};

export default SeatApplicationManagerContext;
